import { constructFrom as u } from "./constructFrom.js";
import { getWeekYear as D } from "./getWeekYear.js";
import { startOfWeek as C } from "./startOfWeek.js";
import { getDefaultOptions as O } from "./_lib/defaultOptions.js";
function x(r, e) {
  var f, s, n, c, i, k, l, m;
  const a = O(), o = (m = (l = (c = (n = e == null ? void 0 : e.firstWeekContainsDate) != null ? n : (s = (f = e == null ? void 0 : e.locale) == null ? void 0 : f.options) == null ? void 0 : s.firstWeekContainsDate) != null ? c : a.firstWeekContainsDate) != null ? l : (k = (i = a.locale) == null ? void 0 : i.options) == null ? void 0 : k.firstWeekContainsDate) != null ? m : 1, W = D(r, e), t = u(r, 0);
  return t.setFullYear(W, 0, o), t.setHours(0, 0, 0, 0), C(t, e);
}
export {
  x as default,
  x as startOfWeekYear
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfWeekYear.js
// module id = 1449
// module chunks = 67